export const CATEGORIES = [
  'Appliances', 'Banking', 'Beauty', 'Buses', 'Cars', 'Charity', 'Children', 'Chagim', 'Chugim', 'Cleaner',
  'Clothes', 'Concerts/Shows', 'Education', 'Entertainment', 'Flights', 'Furniture', 'Gifts', 'Hardware', 'Health',
  'Holiday Apartments', 'Home', 'Insurance', 'Investments', 'Maintenance', 'Meetings', 'Medical', 'Nicotine',
  'Online Shopping', 'Outings', 'Parking', 'Parties', 'Pets', 'Pharmacy', 'Reading', 'Refurbishing', 'Religion',
  'Restaurants', 'Stationary', 'Shopping', 'Taxes and Fines', 'Technology', 'Therapists', 'Toys', 'Transportation', 'Utilities'
];

export const PAYMENT_TYPES = ['Cash', 'Check', 'Wire', 'Change', 'Credit Card'];

export const KIDS = ['Yosef', 'Binyamin', 'Rachel', 'Leah', 'Eliyahu', 'David', 'Esther', 'Akiva', 'Elisheva'];

export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const categoryOptions = CATEGORIES.map(item => ({ value: item, label: item }));
export const paymentTypeOptions = PAYMENT_TYPES.map(item => ({ value: item, label: item }));
export const kidOptions = KIDS.map(item => ({ value: item, label: item }));

// Return exactly `count` colors: the palette first, then generated golden-angle hues so
// categories past the palette's end never fall back to Chart.js's default grey.
export function extendPalette(palette, count, { lightness = 55, alpha = 0.8 } = {}) {
  return Array.from({ length: count }, (_, i) =>
    i < palette.length ? palette[i] : `hsla(${Math.round((i * 137.508) % 360)}, 70%, ${lightness}%, ${alpha})`
  );
}
